module.exports = "/images/switch-jobs.svg?8381f051a72af63e8077d05fe28f58b2";